import { isEmpty } from '../../utilities/isEmpty.js';
import 'react';
import { a as _objectSpread2 } from '../../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import 'lodash.isnil';
import { removeField } from '../utils.js';
import { actions } from './constants.js';
import isEqual from 'lodash.isequal';

const getInitialState = initialFilters => {
  return {
    isDrawerOpen: false,
    appliedFilters: initialFilters,
    toBeAppliedFilters: initialFilters,
    lastUpdatedElementId: null
  };
};
const reducer = (state, action) => {
  switch (action.type) {
    case actions.drawer.opened:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isDrawerOpen: true
      });
    case actions.drawer.closed:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isDrawerOpen: false
      });
    case actions.filters.setValue:
      {
        const {
          field,
          value
        } = action.payload;
        if (isEmpty(value)) {
          const newToBeAppliedFilters = removeField(state.toBeAppliedFilters, field);
          return _objectSpread2(_objectSpread2({}, state), {}, {
            lastUpdatedElementId: state.appliedFilters[field] ? field : null,
            toBeAppliedFilters: _objectSpread2({}, newToBeAppliedFilters)
          });
        }
        return _objectSpread2(_objectSpread2({}, state), {}, {
          lastUpdatedElementId: field,
          toBeAppliedFilters: _objectSpread2(_objectSpread2({}, state.toBeAppliedFilters), {}, {
            [field]: value
          })
        });
      }
    case actions.filters.save:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isDrawerOpen: false,
        lastUpdatedElementId: null,
        appliedFilters: _objectSpread2({}, state.toBeAppliedFilters)
      });
    case actions.filters.saveOneFiler:
      {
        const {
          field
        } = action.payload;
        const filter = isEmpty(state.toBeAppliedFilters[field]) ? {} : {
          [field]: state.toBeAppliedFilters[field]
        };
        return _objectSpread2(_objectSpread2({}, state), {}, {
          isDrawerOpen: false,
          lastUpdatedElementId: null,
          appliedFilters: _objectSpread2(_objectSpread2({}, state.appliedFilters), filter)
        });
      }
    case actions.filters.dismiss:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isDrawerOpen: false,
        lastUpdatedElementId: null,
        toBeAppliedFilters: _objectSpread2({}, state.appliedFilters)
      });
    case actions.filters.removeValue:
      {
        const {
          value,
          field
        } = action.payload;
        const fieldValues = state.toBeAppliedFilters[field];
        const hasOneItem = (fieldValues === null || fieldValues === void 0 ? void 0 : fieldValues.length) === 1;
        const shouldRemoveField = isEmpty(value) || hasOneItem && isEqual(fieldValues[0], value);
        if (shouldRemoveField) {
          return _objectSpread2(_objectSpread2({}, state), {}, {
            lastUpdatedElementId: null,
            toBeAppliedFilters: _objectSpread2({}, removeField(state.toBeAppliedFilters, field))
          });
        }
        return _objectSpread2(_objectSpread2({}, state), {}, {
          toBeAppliedFilters: _objectSpread2(_objectSpread2({}, state.toBeAppliedFilters), {}, {
            [field]: fieldValues.filter(fieldValue => !isEqual(fieldValue, value))
          })
        });
      }
    case actions.filters.clearAll:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        lastUpdatedElementId: null,
        toBeAppliedFilters: []
      });
    case actions.filters.setFilters:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        appliedFilters: _objectSpread2({}, action.payload.value),
        toBeAppliedFilters: _objectSpread2({}, action.payload.value)
      });
    default:
      return state;
  }
};

export { getInitialState, reducer };
